// extracted by mini-css-extract-plugin
module.exports = {"bg":"submit-publish_bg__y9IhT","btn":"submit-publish_btn__g1Qt8"};